import styles from "../../styles/common/UserDropdownMenu.module.scss"

import React, {useState} from 'react';
import clsx from "clsx";
import Tippy from "@tippyjs/react";

import {useAuth} from "../../providers/AuthProvider";

import Button from "./Button";

interface UserDropdownMenuProps {
  isCollapsed?: boolean;
}

function UserDropdownMenu({ isCollapsed = false }: UserDropdownMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      // Redirect will be handled by AuthCheck component
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div
      className={clsx(
        styles.cUserDropdown, 
        "c-user-dropdown",
        { [styles.collapsed]: isCollapsed }
      )}
    >
      <Tippy
        className="c-user-dropdown-menu"
        interactive
        animation="shift-away"
        placement={isCollapsed ? "right-start" : "bottom-end"}
        trigger="click"
        maxWidth="198px"
        onShow={() => setIsOpen(true)}
        onHide={() => setIsOpen(false)}
        arrow={false}
        content={
            <ul className="c-user-dropdown-menu-list">
              <li>
                <Button
                  extraClassName="c-user-dropdown-menu-list-btn"
                  text="Settings"
                  btnVariant="link"
                  onClick={() => window.location.href = '/settings'}
                />
              </li>
              <li>
                <Button
                  extraClassName="c-user-dropdown-menu-list-btn"
                  text="Sign out"
                  btnVariant="link"
                  onClick={handleLogout}
                />
              </li>
            </ul>
        }
      >
        <button
          title={isOpen ? "Close menu" : "Open menu"}
          className={clsx(
            "c-user-dropdown-toggle", 
            isOpen && "is-open",
            { "collapsed": isCollapsed }
          )}
        >
          <span>
            {user?.email?.slice(0, 2) || 'LC'}
          </span>
          {!isCollapsed && (
            <span className="user-email">
              {user?.email || 'User'}
            </span>
          )}
        </button>
      </Tippy>
    </div>
  );
}

export default UserDropdownMenu;